module.exports = __webpack_public_path__ + "img/520x_06.a299a847.png";